/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ClassificationDto,
  DetailTrackDto,
  FlexUnlockCheckoutRequestDto,
  FlexUnlockCheckoutResponseDto,
  LicenseRequestDto,
  MoveTrackDto,
  PresignUploadRequestDto,
  PresignUploadResponseDto,
  RenameTrackDto,
  TrackBackfillTrackAssetDto,
  TrackMinDto,
  TracksControllerListClassificationsParams,
  TracksControllerTrackCreateBody,
  TracksControllerTrackCreateParams,
  TracksControllerTracksList200,
  TracksControllerTracksListParams,
  TracksControllerTracksUploadPictureBody,
  TracksControllerTracksUploadPreviewBody,
  UnlocksUsageDto,
  UpdateTrackDto,
  UploadQuotaDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const tracksControllerTracksListMoods = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ClassificationDto[]>(
    { url: `/tracks/moods`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerTracksListMoodsQueryKey = () => {
  return [`/tracks/moods`] as const;
};

export const getTracksControllerTracksListMoodsQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerTracksListMoodsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerTracksListMoods>>
  > = ({ signal }) => tracksControllerTracksListMoods(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerTracksListMoodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksListMoods>>
>;
export type TracksControllerTracksListMoodsQueryError = ErrorType<unknown>;

export function useTracksControllerTracksListMoods<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListMoods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerTracksListMoods<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListMoods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerTracksListMoods<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTracksControllerTracksListMoods<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListMoods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerTracksListMoodsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tracksControllerTracksListGenres = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ClassificationDto[]>(
    { url: `/tracks/genres`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerTracksListGenresQueryKey = () => {
  return [`/tracks/genres`] as const;
};

export const getTracksControllerTracksListGenresQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerTracksListGenresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerTracksListGenres>>
  > = ({ signal }) => tracksControllerTracksListGenres(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerTracksListGenresQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksListGenres>>
>;
export type TracksControllerTracksListGenresQueryError = ErrorType<unknown>;

export function useTracksControllerTracksListGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListGenres>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerTracksListGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListGenres>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerTracksListGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTracksControllerTracksListGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListGenres>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerTracksListGenresQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tracksControllerTracksListSoundkitTypes = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ClassificationDto[]>(
    { url: `/tracks/soundkit-types`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerTracksListSoundkitTypesQueryKey = () => {
  return [`/tracks/soundkit-types`] as const;
};

export const getTracksControllerTracksListSoundkitTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTracksControllerTracksListSoundkitTypesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>
  > = ({ signal }) =>
    tracksControllerTracksListSoundkitTypes(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerTracksListSoundkitTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>
>;
export type TracksControllerTracksListSoundkitTypesQueryError =
  ErrorType<unknown>;

export function useTracksControllerTracksListSoundkitTypes<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerTracksListSoundkitTypes<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerTracksListSoundkitTypes<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTracksControllerTracksListSoundkitTypes<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSoundkitTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getTracksControllerTracksListSoundkitTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tracksControllerUnlockUsage = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UnlocksUsageDto>(
    { url: `/tracks/unlock-usage`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerUnlockUsageQueryKey = () => {
  return [`/tracks/unlock-usage`] as const;
};

export const getTracksControllerUnlockUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerUnlockUsageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerUnlockUsage>>
  > = ({ signal }) => tracksControllerUnlockUsage(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerUnlockUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerUnlockUsage>>
>;
export type TracksControllerUnlockUsageQueryError = ErrorType<unknown>;

export function useTracksControllerUnlockUsage<
  TData = Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerUnlockUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerUnlockUsage<
  TData = Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerUnlockUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerUnlockUsage<
  TData = Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTracksControllerUnlockUsage<
  TData = Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUnlockUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerUnlockUsageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tracksControllerUploadCount = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<number>(
    { url: `/tracks/upload-count`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerUploadCountQueryKey = () => {
  return [`/tracks/upload-count`] as const;
};

export const getTracksControllerUploadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerUploadCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tracksControllerUploadCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerUploadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerUploadCount>>
  > = ({ signal }) => tracksControllerUploadCount(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerUploadCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerUploadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerUploadCount>>
>;
export type TracksControllerUploadCountQueryError = ErrorType<unknown>;

export function useTracksControllerUploadCount<
  TData = Awaited<ReturnType<typeof tracksControllerUploadCount>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerUploadCount>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerUploadCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerUploadCount<
  TData = Awaited<ReturnType<typeof tracksControllerUploadCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerUploadCount>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerUploadCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerUploadCount<
  TData = Awaited<ReturnType<typeof tracksControllerUploadCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useTracksControllerUploadCount<
  TData = Awaited<ReturnType<typeof tracksControllerUploadCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerUploadCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Current usage of the free tier's monthly upload quota
 */
export const tracksControllerUploadQuota = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UploadQuotaDto>(
    { url: `/tracks/upload-quota`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerUploadQuotaQueryKey = () => {
  return [`/tracks/upload-quota`] as const;
};

export const getTracksControllerUploadQuotaQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerUploadQuotaQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerUploadQuota>>
  > = ({ signal }) => tracksControllerUploadQuota(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerUploadQuotaQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerUploadQuota>>
>;
export type TracksControllerUploadQuotaQueryError = ErrorType<unknown>;

export function useTracksControllerUploadQuota<
  TData = Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerUploadQuota>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerUploadQuota<
  TData = Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerUploadQuota>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerUploadQuota<
  TData = Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Current usage of the free tier's monthly upload quota
 */

export function useTracksControllerUploadQuota<
  TData = Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerUploadQuota>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerUploadQuotaQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List sub-genres for a genre
 */
export const tracksControllerTracksListSubGenres = (
  genreId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ClassificationDto[]>(
    { url: `/tracks/genres/${genreId}/sub-genres`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerTracksListSubGenresQueryKey = (
  genreId?: string,
) => {
  return [`/tracks/genres/${genreId}/sub-genres`] as const;
};

export const getTracksControllerTracksListSubGenresQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
  TError = ErrorType<unknown>,
>(
  genreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTracksControllerTracksListSubGenresQueryKey(genreId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>
  > = ({ signal }) =>
    tracksControllerTracksListSubGenres(genreId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!genreId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerTracksListSubGenresQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>
>;
export type TracksControllerTracksListSubGenresQueryError = ErrorType<unknown>;

export function useTracksControllerTracksListSubGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
  TError = ErrorType<unknown>,
>(
  genreId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerTracksListSubGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
  TError = ErrorType<unknown>,
>(
  genreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerTracksListSubGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
  TError = ErrorType<unknown>,
>(
  genreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List sub-genres for a genre
 */

export function useTracksControllerTracksListSubGenres<
  TData = Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
  TError = ErrorType<unknown>,
>(
  genreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksListSubGenres>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerTracksListSubGenresQueryOptions(
    genreId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List track classifications by type
 */
export const tracksControllerListClassifications = (
  params: TracksControllerListClassificationsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ClassificationDto[]>(
    { url: `/tracks/classifications`, method: "GET", params, signal },
    options,
  );
};

export const getTracksControllerListClassificationsQueryKey = (
  params?: TracksControllerListClassificationsParams,
) => {
  return [`/tracks/classifications`, ...(params ? [params] : [])] as const;
};

export const getTracksControllerListClassificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerListClassifications>>,
  TError = ErrorType<unknown>,
>(
  params: TracksControllerListClassificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerListClassifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTracksControllerListClassificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerListClassifications>>
  > = ({ signal }) =>
    tracksControllerListClassifications(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerListClassifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerListClassificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerListClassifications>>
>;
export type TracksControllerListClassificationsQueryError = ErrorType<unknown>;

export function useTracksControllerListClassifications<
  TData = Awaited<ReturnType<typeof tracksControllerListClassifications>>,
  TError = ErrorType<unknown>,
>(
  params: TracksControllerListClassificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerListClassifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerListClassifications>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerListClassifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerListClassifications<
  TData = Awaited<ReturnType<typeof tracksControllerListClassifications>>,
  TError = ErrorType<unknown>,
>(
  params: TracksControllerListClassificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerListClassifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerListClassifications>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerListClassifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerListClassifications<
  TData = Awaited<ReturnType<typeof tracksControllerListClassifications>>,
  TError = ErrorType<unknown>,
>(
  params: TracksControllerListClassificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerListClassifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List track classifications by type
 */

export function useTracksControllerListClassifications<
  TData = Awaited<ReturnType<typeof tracksControllerListClassifications>>,
  TError = ErrorType<unknown>,
>(
  params: TracksControllerListClassificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerListClassifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerListClassificationsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a presigned URL for direct S3 upload
 */
export const tracksControllerPresignUpload = (
  presignUploadRequestDto: BodyType<PresignUploadRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<PresignUploadResponseDto>(
    {
      url: `/tracks/presign-upload`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: presignUploadRequestDto,
      signal,
    },
    options,
  );
};

export const getTracksControllerPresignUploadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerPresignUpload>>,
    TError,
    { data: BodyType<PresignUploadRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerPresignUpload>>,
  TError,
  { data: BodyType<PresignUploadRequestDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerPresignUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerPresignUpload>>,
    { data: BodyType<PresignUploadRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return tracksControllerPresignUpload(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerPresignUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerPresignUpload>>
>;
export type TracksControllerPresignUploadMutationBody =
  BodyType<PresignUploadRequestDto>;
export type TracksControllerPresignUploadMutationError = ErrorType<unknown>;

/**
 * @summary Get a presigned URL for direct S3 upload
 */
export const useTracksControllerPresignUpload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerPresignUpload>>,
      TError,
      { data: BodyType<PresignUploadRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerPresignUpload>>,
  TError,
  { data: BodyType<PresignUploadRequestDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerPresignUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create a new track
 */
export const tracksControllerTrackCreate = (
  tracksControllerTrackCreateBody: BodyType<TracksControllerTrackCreateBody>,
  params: TracksControllerTrackCreateParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (tracksControllerTrackCreateBody.file !== undefined) {
    formData.append(`file`, tracksControllerTrackCreateBody.file);
  }

  return apiRequest<TrackMinDto>(
    {
      url: `/tracks`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      params,
      signal,
    },
    options,
  );
};

export const getTracksControllerTrackCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTrackCreate>>,
    TError,
    {
      data: BodyType<TracksControllerTrackCreateBody>;
      params: TracksControllerTrackCreateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTrackCreate>>,
  TError,
  {
    data: BodyType<TracksControllerTrackCreateBody>;
    params: TracksControllerTrackCreateParams;
  },
  TContext
> => {
  const mutationKey = ["tracksControllerTrackCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTrackCreate>>,
    {
      data: BodyType<TracksControllerTrackCreateBody>;
      params: TracksControllerTrackCreateParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return tracksControllerTrackCreate(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTrackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackCreate>>
>;
export type TracksControllerTrackCreateMutationBody =
  BodyType<TracksControllerTrackCreateBody>;
export type TracksControllerTrackCreateMutationError = ErrorType<unknown>;

/**
 * @summary Create a new track
 */
export const useTracksControllerTrackCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTrackCreate>>,
      TError,
      {
        data: BodyType<TracksControllerTrackCreateBody>;
        params: TracksControllerTrackCreateParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTrackCreate>>,
  TError,
  {
    data: BodyType<TracksControllerTrackCreateBody>;
    params: TracksControllerTrackCreateParams;
  },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTrackCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List tracks
 */
export const tracksControllerTracksList = (
  params?: TracksControllerTracksListParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TracksControllerTracksList200>(
    { url: `/tracks`, method: "GET", params, signal },
    options,
  );
};

export const getTracksControllerTracksListQueryKey = (
  params?: TracksControllerTracksListParams,
) => {
  return [`/tracks`, ...(params ? [params] : [])] as const;
};

export const getTracksControllerTracksListQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerTracksList>>,
  TError = ErrorType<unknown>,
>(
  params?: TracksControllerTracksListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerTracksListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerTracksList>>
  > = ({ signal }) =>
    tracksControllerTracksList(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerTracksList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerTracksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksList>>
>;
export type TracksControllerTracksListQueryError = ErrorType<unknown>;

export function useTracksControllerTracksList<
  TData = Awaited<ReturnType<typeof tracksControllerTracksList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TracksControllerTracksListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksList>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerTracksList<
  TData = Awaited<ReturnType<typeof tracksControllerTracksList>>,
  TError = ErrorType<unknown>,
>(
  params?: TracksControllerTracksListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTracksList>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTracksList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerTracksList<
  TData = Awaited<ReturnType<typeof tracksControllerTracksList>>,
  TError = ErrorType<unknown>,
>(
  params?: TracksControllerTracksListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List tracks
 */

export function useTracksControllerTracksList<
  TData = Awaited<ReturnType<typeof tracksControllerTracksList>>,
  TError = ErrorType<unknown>,
>(
  params?: TracksControllerTracksListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTracksList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerTracksListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tracksControllerTrackUpdate = (
  updateTrackDto: BodyType<UpdateTrackDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/tracks`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateTrackDto,
    },
    options,
  );
};

export const getTracksControllerTrackUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTrackUpdate>>,
    TError,
    { data: BodyType<UpdateTrackDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTrackUpdate>>,
  TError,
  { data: BodyType<UpdateTrackDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerTrackUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTrackUpdate>>,
    { data: BodyType<UpdateTrackDto> }
  > = (props) => {
    const { data } = props ?? {};

    return tracksControllerTrackUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTrackUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackUpdate>>
>;
export type TracksControllerTrackUpdateMutationBody = BodyType<UpdateTrackDto>;
export type TracksControllerTrackUpdateMutationError = ErrorType<unknown>;

export const useTracksControllerTrackUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTrackUpdate>>,
      TError,
      { data: BodyType<UpdateTrackDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTrackUpdate>>,
  TError,
  { data: BodyType<UpdateTrackDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTrackUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Record a play event for a track
 */
export const tracksControllerRecordPlay = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/play`, method: "POST", signal },
    options,
  );
};

export const getTracksControllerRecordPlayMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerRecordPlay>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerRecordPlay>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerRecordPlay"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerRecordPlay>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerRecordPlay(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerRecordPlayMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerRecordPlay>>
>;

export type TracksControllerRecordPlayMutationError = ErrorType<unknown>;

/**
 * @summary Record a play event for a track
 */
export const useTracksControllerRecordPlay = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerRecordPlay>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerRecordPlay>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions = getTracksControllerRecordPlayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Detail a track
 */
export const tracksControllerTrackDetail = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DetailTrackDto>(
    { url: `/tracks/${trackId}`, method: "GET", signal },
    options,
  );
};

export const getTracksControllerTrackDetailQueryKey = (trackId?: string) => {
  return [`/tracks/${trackId}`] as const;
};

export const getTracksControllerTrackDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTracksControllerTrackDetailQueryKey(trackId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof tracksControllerTrackDetail>>
  > = ({ signal }) =>
    tracksControllerTrackDetail(trackId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!trackId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TracksControllerTrackDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackDetail>>
>;
export type TracksControllerTrackDetailQueryError = ErrorType<unknown>;

export function useTracksControllerTrackDetail<
  TData = Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTrackDetail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTracksControllerTrackDetail<
  TData = Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
          TError,
          Awaited<ReturnType<typeof tracksControllerTrackDetail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTracksControllerTrackDetail<
  TData = Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Detail a track
 */

export function useTracksControllerTrackDetail<
  TData = Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
  TError = ErrorType<unknown>,
>(
  trackId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof tracksControllerTrackDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTracksControllerTrackDetailQueryOptions(
    trackId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a track
 */
export const tracksControllerTrackDelete = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}`, method: "DELETE" },
    options,
  );
};

export const getTracksControllerTrackDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTrackDelete>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTrackDelete>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerTrackDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTrackDelete>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerTrackDelete(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTrackDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackDelete>>
>;

export type TracksControllerTrackDeleteMutationError = ErrorType<unknown>;

/**
 * @summary Delete a track
 */
export const useTracksControllerTrackDelete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTrackDelete>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTrackDelete>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTrackDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reprocess a track
 */
export const tracksControllerReprocess = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/reprocess`, method: "POST", signal },
    options,
  );
};

export const getTracksControllerReprocessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerReprocess>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerReprocess>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerReprocess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerReprocess>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerReprocess(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerReprocessMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerReprocess>>
>;

export type TracksControllerReprocessMutationError = ErrorType<unknown>;

/**
 * @summary Reprocess a track
 */
export const useTracksControllerReprocess = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerReprocess>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerReprocess>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions = getTracksControllerReprocessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Rename a track (title only)
 */
export const tracksControllerTrackRename = (
  trackId: string,
  renameTrackDto: BodyType<RenameTrackDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackMinDto>(
    {
      url: `/tracks/${trackId}/title`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: renameTrackDto,
    },
    options,
  );
};

export const getTracksControllerTrackRenameMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTrackRename>>,
    TError,
    { trackId: string; data: BodyType<RenameTrackDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTrackRename>>,
  TError,
  { trackId: string; data: BodyType<RenameTrackDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerTrackRename"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTrackRename>>,
    { trackId: string; data: BodyType<RenameTrackDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return tracksControllerTrackRename(trackId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTrackRenameMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackRename>>
>;
export type TracksControllerTrackRenameMutationBody = BodyType<RenameTrackDto>;
export type TracksControllerTrackRenameMutationError = ErrorType<unknown>;

/**
 * @summary Rename a track (title only)
 */
export const useTracksControllerTrackRename = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTrackRename>>,
      TError,
      { trackId: string; data: BodyType<RenameTrackDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTrackRename>>,
  TError,
  { trackId: string; data: BodyType<RenameTrackDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTrackRenameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Move a track to another creator within the same label
 */
export const tracksControllerMoveTrackCreator = (
  trackId: string,
  moveTrackDto: BodyType<MoveTrackDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<TrackMinDto>(
    {
      url: `/tracks/${trackId}/creator`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: moveTrackDto,
    },
    options,
  );
};

export const getTracksControllerMoveTrackCreatorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerMoveTrackCreator>>,
    TError,
    { trackId: string; data: BodyType<MoveTrackDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerMoveTrackCreator>>,
  TError,
  { trackId: string; data: BodyType<MoveTrackDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerMoveTrackCreator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerMoveTrackCreator>>,
    { trackId: string; data: BodyType<MoveTrackDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return tracksControllerMoveTrackCreator(trackId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerMoveTrackCreatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerMoveTrackCreator>>
>;
export type TracksControllerMoveTrackCreatorMutationBody =
  BodyType<MoveTrackDto>;
export type TracksControllerMoveTrackCreatorMutationError = ErrorType<unknown>;

/**
 * @summary Move a track to another creator within the same label
 */
export const useTracksControllerMoveTrackCreator = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerMoveTrackCreator>>,
      TError,
      { trackId: string; data: BodyType<MoveTrackDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerMoveTrackCreator>>,
  TError,
  { trackId: string; data: BodyType<MoveTrackDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerMoveTrackCreatorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload a track's picture
 */
export const tracksControllerTracksUploadPicture = (
  trackId: string,
  tracksControllerTracksUploadPictureBody: BodyType<TracksControllerTracksUploadPictureBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tracksControllerTracksUploadPictureBody.file);

  return apiRequest<void>(
    {
      url: `/tracks/${trackId}/picture`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getTracksControllerTracksUploadPictureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTracksUploadPicture>>,
    TError,
    {
      trackId: string;
      data: BodyType<TracksControllerTracksUploadPictureBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTracksUploadPicture>>,
  TError,
  { trackId: string; data: BodyType<TracksControllerTracksUploadPictureBody> },
  TContext
> => {
  const mutationKey = ["tracksControllerTracksUploadPicture"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTracksUploadPicture>>,
    { trackId: string; data: BodyType<TracksControllerTracksUploadPictureBody> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return tracksControllerTracksUploadPicture(trackId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTracksUploadPictureMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksUploadPicture>>
>;
export type TracksControllerTracksUploadPictureMutationBody =
  BodyType<TracksControllerTracksUploadPictureBody>;
export type TracksControllerTracksUploadPictureMutationError =
  ErrorType<unknown>;

/**
 * @summary Upload a track's picture
 */
export const useTracksControllerTracksUploadPicture = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTracksUploadPicture>>,
      TError,
      {
        trackId: string;
        data: BodyType<TracksControllerTracksUploadPictureBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTracksUploadPicture>>,
  TError,
  { trackId: string; data: BodyType<TracksControllerTracksUploadPictureBody> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTracksUploadPictureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a track's picture
 */
export const tracksControllerTracksDeletePicture = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/picture`, method: "DELETE" },
    options,
  );
};

export const getTracksControllerTracksDeletePictureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTracksDeletePicture>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTracksDeletePicture>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerTracksDeletePicture"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTracksDeletePicture>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerTracksDeletePicture(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTracksDeletePictureMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksDeletePicture>>
>;

export type TracksControllerTracksDeletePictureMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete a track's picture
 */
export const useTracksControllerTracksDeletePicture = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTracksDeletePicture>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTracksDeletePicture>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTracksDeletePictureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload a track's preview audio file
 */
export const tracksControllerTracksUploadPreview = (
  trackId: string,
  tracksControllerTracksUploadPreviewBody: BodyType<TracksControllerTracksUploadPreviewBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tracksControllerTracksUploadPreviewBody.file);

  return apiRequest<void>(
    {
      url: `/tracks/${trackId}/preview`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getTracksControllerTracksUploadPreviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTracksUploadPreview>>,
    TError,
    {
      trackId: string;
      data: BodyType<TracksControllerTracksUploadPreviewBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTracksUploadPreview>>,
  TError,
  { trackId: string; data: BodyType<TracksControllerTracksUploadPreviewBody> },
  TContext
> => {
  const mutationKey = ["tracksControllerTracksUploadPreview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTracksUploadPreview>>,
    { trackId: string; data: BodyType<TracksControllerTracksUploadPreviewBody> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return tracksControllerTracksUploadPreview(trackId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTracksUploadPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksUploadPreview>>
>;
export type TracksControllerTracksUploadPreviewMutationBody =
  BodyType<TracksControllerTracksUploadPreviewBody>;
export type TracksControllerTracksUploadPreviewMutationError =
  ErrorType<unknown>;

/**
 * @summary Upload a track's preview audio file
 */
export const useTracksControllerTracksUploadPreview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTracksUploadPreview>>,
      TError,
      {
        trackId: string;
        data: BodyType<TracksControllerTracksUploadPreviewBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTracksUploadPreview>>,
  TError,
  { trackId: string; data: BodyType<TracksControllerTracksUploadPreviewBody> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTracksUploadPreviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a track's preview audio file
 */
export const tracksControllerTracksDeletePreview = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/preview`, method: "DELETE" },
    options,
  );
};

export const getTracksControllerTracksDeletePreviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTracksDeletePreview>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTracksDeletePreview>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerTracksDeletePreview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTracksDeletePreview>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerTracksDeletePreview(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTracksDeletePreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTracksDeletePreview>>
>;

export type TracksControllerTracksDeletePreviewMutationError =
  ErrorType<unknown>;

/**
 * @summary Delete a track's preview audio file
 */
export const useTracksControllerTracksDeletePreview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTracksDeletePreview>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTracksDeletePreview>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTracksDeletePreviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create or update a track's license configuration
 */
export const tracksControllerHandleLicenseConfiguration = (
  trackId: string,
  licenseRequestDto: BodyType<LicenseRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LicenseRequestDto>(
    {
      url: `/tracks/${trackId}/license-configuration`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: licenseRequestDto,
      signal,
    },
    options,
  );
};

export const getTracksControllerHandleLicenseConfigurationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerHandleLicenseConfiguration>>,
    TError,
    { trackId: string; data: BodyType<LicenseRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerHandleLicenseConfiguration>>,
  TError,
  { trackId: string; data: BodyType<LicenseRequestDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerHandleLicenseConfiguration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerHandleLicenseConfiguration>>,
    { trackId: string; data: BodyType<LicenseRequestDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return tracksControllerHandleLicenseConfiguration(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerHandleLicenseConfigurationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof tracksControllerHandleLicenseConfiguration>>
  >;
export type TracksControllerHandleLicenseConfigurationMutationBody =
  BodyType<LicenseRequestDto>;
export type TracksControllerHandleLicenseConfigurationMutationError =
  ErrorType<unknown>;

/**
 * @summary Create or update a track's license configuration
 */
export const useTracksControllerHandleLicenseConfiguration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerHandleLicenseConfiguration>>,
      TError,
      { trackId: string; data: BodyType<LicenseRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerHandleLicenseConfiguration>>,
  TError,
  { trackId: string; data: BodyType<LicenseRequestDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerHandleLicenseConfigurationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Publish a track
 */
export const tracksControllerTrackPublish = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/publish`, method: "POST", signal },
    options,
  );
};

export const getTracksControllerTrackPublishMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTrackPublish>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTrackPublish>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerTrackPublish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTrackPublish>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerTrackPublish(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTrackPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackPublish>>
>;

export type TracksControllerTrackPublishMutationError = ErrorType<unknown>;

/**
 * @summary Publish a track
 */
export const useTracksControllerTrackPublish = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTrackPublish>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTrackPublish>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTrackPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unpublish a track
 */
export const tracksControllerTrackUnpublish = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/publish`, method: "DELETE" },
    options,
  );
};

export const getTracksControllerTrackUnpublishMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerTrackUnpublish>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerTrackUnpublish>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerTrackUnpublish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerTrackUnpublish>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerTrackUnpublish(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerTrackUnpublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerTrackUnpublish>>
>;

export type TracksControllerTrackUnpublishMutationError = ErrorType<unknown>;

/**
 * @summary Unpublish a track
 */
export const useTracksControllerTrackUnpublish = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerTrackUnpublish>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerTrackUnpublish>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTracksControllerTrackUnpublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unlock a track for asset download
 */
export const tracksControllerUnlockTrack = (
  trackId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/tracks/${trackId}/unlock`, method: "POST", signal },
    options,
  );
};

export const getTracksControllerUnlockTrackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerUnlockTrack>>,
    TError,
    { trackId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerUnlockTrack>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationKey = ["tracksControllerUnlockTrack"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerUnlockTrack>>,
    { trackId: string }
  > = (props) => {
    const { trackId } = props ?? {};

    return tracksControllerUnlockTrack(trackId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerUnlockTrackMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerUnlockTrack>>
>;

export type TracksControllerUnlockTrackMutationError = ErrorType<unknown>;

/**
 * @summary Unlock a track for asset download
 */
export const useTracksControllerUnlockTrack = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerUnlockTrack>>,
      TError,
      { trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerUnlockTrack>>,
  TError,
  { trackId: string },
  TContext
> => {
  const mutationOptions =
    getTracksControllerUnlockTrackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create Stripe Checkout session for flex user track unlock
 */
export const tracksControllerCreateFlexUnlockCheckout = (
  trackId: string,
  flexUnlockCheckoutRequestDto: BodyType<FlexUnlockCheckoutRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<FlexUnlockCheckoutResponseDto>(
    {
      url: `/tracks/${trackId}/unlock-checkout`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: flexUnlockCheckoutRequestDto,
      signal,
    },
    options,
  );
};

export const getTracksControllerCreateFlexUnlockCheckoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerCreateFlexUnlockCheckout>>,
    TError,
    { trackId: string; data: BodyType<FlexUnlockCheckoutRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerCreateFlexUnlockCheckout>>,
  TError,
  { trackId: string; data: BodyType<FlexUnlockCheckoutRequestDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerCreateFlexUnlockCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerCreateFlexUnlockCheckout>>,
    { trackId: string; data: BodyType<FlexUnlockCheckoutRequestDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return tracksControllerCreateFlexUnlockCheckout(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerCreateFlexUnlockCheckoutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof tracksControllerCreateFlexUnlockCheckout>>
  >;
export type TracksControllerCreateFlexUnlockCheckoutMutationBody =
  BodyType<FlexUnlockCheckoutRequestDto>;
export type TracksControllerCreateFlexUnlockCheckoutMutationError =
  ErrorType<unknown>;

/**
 * @summary Create Stripe Checkout session for flex user track unlock
 */
export const useTracksControllerCreateFlexUnlockCheckout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerCreateFlexUnlockCheckout>>,
      TError,
      { trackId: string; data: BodyType<FlexUnlockCheckoutRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerCreateFlexUnlockCheckout>>,
  TError,
  { trackId: string; data: BodyType<FlexUnlockCheckoutRequestDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerCreateFlexUnlockCheckoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Scope the run with trackId, creatorId and/or limit before going bulk. The response only returns once every matching track is enqueued, so use limit to keep very large catalogues within the request timeout.
 * @summary Create a track process for every SONG/BEAT missing the given asset type
 */
export const tracksControllerBackfillTrackAssets = (
  trackBackfillTrackAssetDto: BodyType<TrackBackfillTrackAssetDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/tracks/backfill-track-assets`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: trackBackfillTrackAssetDto,
      signal,
    },
    options,
  );
};

export const getTracksControllerBackfillTrackAssetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tracksControllerBackfillTrackAssets>>,
    TError,
    { data: BodyType<TrackBackfillTrackAssetDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tracksControllerBackfillTrackAssets>>,
  TError,
  { data: BodyType<TrackBackfillTrackAssetDto> },
  TContext
> => {
  const mutationKey = ["tracksControllerBackfillTrackAssets"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tracksControllerBackfillTrackAssets>>,
    { data: BodyType<TrackBackfillTrackAssetDto> }
  > = (props) => {
    const { data } = props ?? {};

    return tracksControllerBackfillTrackAssets(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TracksControllerBackfillTrackAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof tracksControllerBackfillTrackAssets>>
>;
export type TracksControllerBackfillTrackAssetsMutationBody =
  BodyType<TrackBackfillTrackAssetDto>;
export type TracksControllerBackfillTrackAssetsMutationError =
  ErrorType<unknown>;

/**
 * @summary Create a track process for every SONG/BEAT missing the given asset type
 */
export const useTracksControllerBackfillTrackAssets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tracksControllerBackfillTrackAssets>>,
      TError,
      { data: BodyType<TrackBackfillTrackAssetDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tracksControllerBackfillTrackAssets>>,
  TError,
  { data: BodyType<TrackBackfillTrackAssetDto> },
  TContext
> => {
  const mutationOptions =
    getTracksControllerBackfillTrackAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
